import {IFluxStandardAction} from "@fkhplus/common/src/modules/interfaces";
import {DefaultTheme} from "styled-components";

const actionTypePrefix = 'Theme/';

const ThemeActionTypes = {
    SWITCH: `${actionTypePrefix}SWITCH`,
    SWITCH_SUCCESS: `${actionTypePrefix}SWITCH_SUCCESS`,
};
export type ThemePayload = DefaultTheme | string;

const switchTheme = (themeName: string): IFluxStandardAction<string> => {
    return {
        type: ThemeActionTypes.SWITCH,
        payload: themeName
    };
}

const switchThemeSuccess = (theme: DefaultTheme): IFluxStandardAction<DefaultTheme> => {
    return {
        type: ThemeActionTypes.SWITCH_SUCCESS,
        payload: theme,
    };
}

const ThemeAction = {
    switchTheme,
    switchThemeSuccess,
};
export {ThemeActionTypes};
export default ThemeAction;